<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />

                <a-button class="item" icon="icon icon-reset" @click="load()" />

                <a-button class="item" icon="replay" v-if="$route.query.in_search" primary @click="on_load" />

                <a-divider type="vertical" class="item" />

                <a-dropdown ref="moreButton" class="item">
                    <a-menu slot="overlay">
                        <a-menu-item @click="on_move_tags(selected_rows)" :disabled="!selected_row_keys.length">编辑标签</a-menu-item>
                        <a-menu-item
                            v-if="permissible.indexOf('member.distribute') > -1"
                            @click="on_distribute(selected_rows)"
                            :disabled="!selected_row_keys.length"
                            >更改销售</a-menu-item
                        >
                    </a-menu>
                    <a-button icon="icon icon-caozuo"></a-button>
                </a-dropdown>

                <template v-if="selected_row_keys.length">
                    <a-divider type="vertical" class="item" />

                    <span class="item selected">
                        已选中：
                        <span class="num">{{ selected_row_keys.length }}</span
                        >条
                    </span>
                </template>
            </div>

            <div class="right-items">
                <a-input-search placeholder="搜索姓名、手机号码" enter-button @search="on_search" class="item" v-model="wd" />

                <a-dropdown-button @click="on_dir_change">
                    {{ sort_field_text }}
                    <a-menu slot="overlay">
                        <template v-for="item in sort_field_columns">
                            <a-menu-item v-if="sort_field != item.value" :key="item.value" @click="on_sort_change(item.value)">{{
                                item.name
                            }}</a-menu-item>
                        </template>
                    </a-menu>

                    <a-icon :type="sort_dir === 'asc' ? 'sort-ascending' : 'sort-descending'" slot="icon" />
                </a-dropdown-button>
            </div>
        </div>

        <!-- 主体表格 -->
        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                :custom-row="custom_row"
                size="middle"
                :scroll="{ x: true }"
                @change="(e) => on_pagination_change(e, path)"
            >
                <template slot="recharge_expense" slot-scope="text, record">
                    <table class="b-table">
                        <tbody>
                            <tr>
                                <td width="40">余额</td>
                                <td>{{ record.balance || "" }}</td>
                            </tr>
                            <tr>
                                <td>冻结</td>
                                <td>{{ record.balance_frozen || "" }}</td>
                            </tr>
                            <tr>
                                <td>总消费</td>
                                <td>{{ record.recharge_total || "" }}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>

                <template slot="id" slot-scope="text, record">
                    <div class="ida">
                        <div class="id">
                            <a-dropdown>
                                <span class="ant-dropdown-link pointer" @click="(e) => e.preventDefault()">
                                    {{ record.id }} <a-icon type="down" />
                                </span>

                                <a-menu slot="overlay">
                                    <a-menu-item key="edit" @click="on_show(record)"><a-icon type="ellipsis" />详情</a-menu-item>
                                    <a-menu-divider />
                                    <a-menu-item @click="on_move_tags([record])"><a-icon type="tags" />编辑标签</a-menu-item>

                                    <a-menu-item key="reset_password" @click="on_reset_password(record)"
                                        ><a-icon type="icon icon-mima"></a-icon>修改登录密码</a-menu-item
                                    >

                                    <a-menu-item
                                        v-if="permissible.indexOf('member.distribute') > -1"
                                        key="distribute"
                                        @click="on_distribute([record])"
                                        ><a-icon type="user" />更改销售</a-menu-item
                                    >
                                    <a-menu-divider />
                                    <a-menu-item @click="redirect(`/order/whole?member_id=${record.id}`)"
                                        ><a-icon type="icon icon-link1"></a-icon><span>查看他的订单</span>
                                    </a-menu-item>
                                    <a-menu-item @click="redirect(`/finance/transaction?member_id=${record.id}`)"
                                        ><a-icon type="icon icon-link1"></a-icon><span>查看他的交易流水</span></a-menu-item
                                    >
                                    <a-menu-item @click="redirect(`/resource/whole?member_id=${record.id}`)"
                                        ><a-icon type="icon icon-link1"></a-icon><span>查看他的店铺</span></a-menu-item
                                    >
                                    <a-menu-item @click="redirect(`/contract?member_id=${record.id}`)"
                                        ><a-icon type="icon icon-link1"></a-icon><span>查看他的合同</span></a-menu-item
                                    >

                                    <a-menu-divider />

                                    <a-menu-item @click="on_login_user(record)"><a-icon type="mobile" />登录到用户端</a-menu-item>

                                    <template v-if="permissible.indexOf('member.delete') > -1">
                                        <a-menu-divider />
                                        <a-menu-item key="disabled" @click="on_disabled(record)"
                                            ><a-icon type="stop" />禁用（禁止使用平台）</a-menu-item
                                        >

                                        <a-menu-item key="delete" @click="on_delete(record)"><a-icon type="delete" />删除</a-menu-item>
                                    </template>
                                </a-menu>
                            </a-dropdown>
                        </div>
                    </div>
                </template>

                <template slot="remark" slot-scope="text">
                    <div class="remark">{{ text }}</div>
                </template>

                <!-- 等级 -->
                <template slot="name" slot-scope="text, record">
                    <div class="member-name">
                        <div class="name">
                            <a-badge :status="record.login_status == 1 ? 'success' : 'default'" />{{ record.name || "匿名" }}
                            <a-icon
                                v-if="record.verified_at"
                                :class="record.verified_type"
                                class="verified"
                                type="icon icon-renzheng"
                            ></a-icon>
                        </div>
                        <div class="id">
                            <a-tag class="level" :color="record.level > 0 ? 'blue' : ''">L{{ record.level }}</a-tag>

                            ID:{{ record.id }}
                        </div>
                    </div>
                </template>

                <!-- 客户信息   -->
                <template slot="info" slot-scope="text, record">
                    <div class="member-company">
                        <ul>
                            <li v-if="record.identity">
                                <div class="icon">
                                    <a-icon type="icon icon-ziliaofuzhi" />
                                </div>
                                <div class="text">
                                    {{ record.identity_text }}
                                </div>
                            </li>
                            <li v-if="record.com_name">
                                <div class="icon">
                                    <a-icon type="icon icon-gongsi" />
                                </div>
                                <div class="text">
                                    <a
                                        :href="'https://www.qcc.com/search?key=' + record.com_name"
                                        target="_blank"
                                        v-if="record.com_name.length > 5"
                                        >{{ record.com_name }}</a
                                    >
                                    <template v-else>
                                        {{ record.com_name }}
                                    </template>
                                </div>
                            </li>
                            <li v-if="record.resource_count">
                                <div class="icon">
                                    <a-icon type="icon icon-shop" />
                                </div>
                                <div class="text">
                                    <router-link :to="`/resource/search?member_id=${record.id}`" target="_blank"
                                        >{{ record.resource_count }}个店铺
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                    </div>
                </template>

                <!-- 联系方式 -->
                <template slot="contact" slot-scope="text, record">
                    <table class="contact b-table">
                        <tbody>
                            <tr>
                                <td style="text-align:left" width="20">
                                    <i class="anticon anticon-icon icon-phone"></i>
                                </td>
                                <td @click="do_copy(record.mobile)" class="copy">{{ record.mobile }}</td>
                            </tr>
                            <tr v-if="record.qq">
                                <td style="text-align:left">
                                    <a-icon type="icon icon-qq1"></a-icon>
                                </td>
                                <td class="copy" @click="do_copy(record.qq)">{{ record.qq }}</td>
                            </tr>
                            <tr v-if="record.wechat_id">
                                <td style="text-align:left">
                                    <i class="anticon anticon-icon icon-we-chat-s"></i>
                                </td>
                                <td class="copy" @click="do_copy(record.wechat_id)">{{ record.wechat_id }}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>

                <!-- 跟进动态 -->
                <template slot="revisit" slot-scope="text, record">
                    <revisit-render :record="text" :member="record" :count="record.revisit_count" :callback="load" />
                </template>

                <!-- 跟进人信息 -->
                <template slot="user" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a"><a-badge :status="text.login_status == 1 ? 'success' : 'default'" />{{ text.name || "匿名" }}</div>
                        <div class="b" v-if="text.group">{{ text.group.name }}</div>
                    </div>
                </template>

                <!-- 注册信息 -->
                <template slot="registered" slot-scope="text, record">
                    <table class="registered b-table">
                        <tbody>
                            <tr>
                                <td style="width:35px">时间</td>
                                <td>
                                    <a-icon type="mobile" v-if="record.init_user_id == 0" style="color:#FF5722" />
                                    <span
                                        v-html="$options.filters['friendly'](moment(record.created_at * 1000).format('YYYY-MM-DD HH:mm'))"
                                    ></span>
                                </td>
                            </tr>
                            <tr>
                                <td>最后</td>
                                <td>
                                    <span
                                        v-html="
                                            record.last_login
                                                ? $options.filters['friendly'](
                                                      moment(record.last_login.created_at * 1000).format('YYYY-MM-DD HH:mm')
                                                  )
                                                : '-'
                                        "
                                    ></span>
                                </td>
                            </tr>
                            <tr>
                                <td>次数</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </template>

                <template slot="action" slot-scope="text, record">
                    <a-dropdown-button @click="on_show(record)" size="small">
                        详情
                        <a-menu slot="overlay">
                            <a-menu-item @click="on_move_tags([record])"><a-icon type="tags" />编辑标签</a-menu-item>

                            <a-menu-item @click="on_reset_password(record)"
                                ><a-icon type="icon icon-mima"></a-icon>修改登录密码</a-menu-item
                            >

                            <a-menu-item
                                v-if="permissible.indexOf('member.distribute') > -1"
                                key="distribute"
                                @click="on_distribute([record])"
                                ><a-icon type="user" />更改销售</a-menu-item
                            >
                            <a-menu-divider />
                            <a-menu-item @click="redirect(`/order/whole?member_id=${record.id}`)"
                                ><a-icon type="icon icon-link1"></a-icon><span>查看他的订单</span>
                            </a-menu-item>
                            <a-menu-item @click="redirect(`/finance/transaction?member_id=${record.id}`)"
                                ><a-icon type="icon icon-link1"></a-icon><span>查看他的交易流水</span></a-menu-item
                            >
                            <a-menu-item @click="redirect(`/resource/whole?member_id=${record.id}`)"
                                ><a-icon type="icon icon-link1"></a-icon><span>查看他的店铺</span></a-menu-item
                            >
                            <a-menu-item @click="redirect(`/contract?member_id=${record.id}`)"
                                ><a-icon type="icon icon-link1"></a-icon><span>查看他的合同</span></a-menu-item
                            >

                            <a-menu-divider />

                            <a-menu-item @click="on_login_user(record)"><a-icon type="mobile" />登录到用户端</a-menu-item>

                            <template v-if="permissible.indexOf('member.delete') > -1">
                                <a-menu-divider />
                                <a-menu-item key="disabled" @click="on_disabled(record)"
                                    ><a-icon type="stop" />禁用（禁止使用平台）</a-menu-item
                                >

                                <a-menu-item key="delete" @click="on_delete(record)"><a-icon type="delete" />删除</a-menu-item>
                            </template>
                        </a-menu>
                    </a-dropdown-button>
                </template>
            </a-table>
        </div>

        <!-- 跟进动态 -->
        <modal_followup :visible="visible_followup" @close="visible_followup = false" @load="load" :callback="load" />

        <!-- 修改密码 -->
        <modal_resetpwd :visible="visible_resetpwd" @close="visible_resetpwd = false" :record="selected_record" />

        <!-- 导出 -->
        <a-modal
            centered
            title="数据导出"
            :width="360"
            :visible="visible_export"
            :confirm-loading="exportting"
            @ok="on_export_submit"
            @cancel="visible_export = false"
        >
            <a-form-model>
                <a-form-model-item label="录入时间区间">
                    <a-range-picker v-model="export_date" :disabledDate="(v) => v >= moment()" value-format="YYYY-MM-DD" />
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
    import modal_followup from "../components/modal_followup.vue";
    import modal_resetpwd from "../components/modal_resetpwd";
    import common_pagination from "../../../mixins/common_pagination.js";

    import moment from "moment";
    import commonjs from "../mixins/common";

    export default {
        mixins: [common_pagination, commonjs],
        components: {
            modal_followup,
            modal_resetpwd,
        },
        data() {
            return {
                sub_title: "客户标签",
                path: "/member/tag",
                loading: false,
                data_source: [],
                trigger: null,
                move_ids: [],
                begin_at: +new Date(),
                wd: null,
                visible_followup: false,
                visible_create: false,
                visible_search: false,
                visible_resetpwd: false,
                visible_show: false,
                selected_record: null,
                tag_id: null,
                columns: [
                    {
                        dataIndex: "name",
                        title: "姓名以及编号",
                        width: 140,
                        scopedSlots: {
                            customRender: "name",
                        },
                    },

                    {
                        dataIndex: "info",
                        title: "其他信息",
                        scopedSlots: {
                            customRender: "info",
                        },
                        width: 160,
                    },
                    {
                        dataIndex: "contact",
                        title: "联系方式",
                        width: 130,
                        scopedSlots: {
                            customRender: "contact",
                        },
                    },
                    {
                        dataIndex: "recharge_expense",
                        title: "充值与消费",
                        width: 120,
                        scopedSlots: {
                            customRender: "recharge_expense",
                        },
                    },
                    {
                        dataIndex: "last_revisit",
                        title: "跟进动态",
                        width: 250,
                        scopedSlots: {
                            customRender: "revisit",
                        },
                    },
                    {
                        dataIndex: "registered",
                        title: "注册信息",
                        width: 160,
                        scopedSlots: {
                            customRender: "registered",
                        },
                    },
                    {
                        dataIndex: "user",
                        title: "跟进人",
                        width: 100,
                        scopedSlots: {
                            customRender: "user",
                        },
                    },
                    {
                        dataIndex: "remark",
                        title: "备注",
                        scopedSlots: {
                            customRender: "remark",
                        },
                    },
                    {
                        dataIndex: "action",
                        title: "操作",
                        width: 100,
                        align: "center",
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        watch: {
            $route() {
                this.reset_query();
                this.selected_row_keys = [];
                this.load();
            },
        },

        created() {
            this.reset_query();
            this.get_tagid();
            this.load();
        },
        computed: {
            profile() {
                return this.$store.state.profile;
            },
        },
        methods: {
            moment,
            get_tagid() {
                this.tag_id = this.$route.params.tag_id;
                this.$store.commit("change_state", {
                    name: "member_sidebar_selected",
                    value: "tag_" + this.tag_id,
                });

                this.path = this.path + "/" + this.tag_id;
            },
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                new_query["tag_id"] = this.tag_id;
                this.$http
                    .get(`/member/tag?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;

                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };

                            //每次加载完数据后再次统计
                            this.load_stat();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>

<style lang="less" scoped>
    .framework-container {
        .framework-body {
            position: absolute;
            left: 200px;
            right: 0;
            bottom: 0;
            top: 0;
            .main {
                overflow-y: auto;
                position: absolute;
                top: 57px;
                left: 0;
                right: 0;
                bottom: 0;
            }
        }

        .contact {
            width: 110px;
            font-size: 12px;
        }
        .user {
            .group {
                font-size: 12px;
                color: #00000080;
            }
        }
        .remark {
            font-size: 12px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
        }
        .member-name {
            .name {
                font-size: 13px;
                margin-bottom: 4px;
            }
            .id {
                font-size: 12px;
                .ant-tag {
                    font-size: 12px;
                    line-height: 18px;
                    padding: 0 4px;
                }
            }
        }

        .member-company {
            ul {
                li {
                    margin-bottom: 4px;
                    font-size: 12px;
                    display: flex;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    .icon {
                        width: 25px;
                        .anticon {
                            font-size: 14px;
                        }
                    }
                    .text {
                        width: 0;
                        flex: 1;
                    }
                }
            }
        }

        .ant-dropdown-menu-item {
            display: flex;
            align-items: center;
        }
    }
</style>
